import { getCurrentInstance } from 'vue'
import { useHead as _useHead } from '#imports'

/**
 * Safely call useHead only when a Vue instance context is available.
 * No-ops otherwise to avoid runtime errors during early plugin/init phases.
 */
export function useSafeHead(input: Parameters<typeof _useHead>[0]) {
  if (getCurrentInstance()) {
    return _useHead(input as any)
  }
  // No-op when called outside of a setup context
  return undefined
}


